import React from "react";
import PropTypes from "prop-types";
import Utils from "../../../utility";
const EmailMarketingSection = ({
  isConsentsEnabled,
  discount,
  widgetSettings
}) => {
  return (
    <div className="flex min-h-84 w-full flex-col items-center">
      <div>
        <p className="flex justify-center text-ft24 font-bold">
          {isConsentsEnabled && discount
            ? `${Utils.isPurelyNumeric(discount) ? discount + "% OFF" : discount}`
            : ""}
        </p>
        <p
          className={`flex text-center font-semibold ${isConsentsEnabled && discount ? "text-ft15" : "text-ft20-28"}`}
        >
          {isConsentsEnabled && discount
            ? "if you let us email you"
            : "Please enter your email address below if you'd like to receive our newsletter"}
        </p>
      </div>
      <div className="w-full max-w-84">
        <input
          type="text"
          className={`${isConsentsEnabled && discount ? "mt-2.5" : "mt-4.5"} flex h-10 w-full justify-center rounded-3xl border px-3 py-1 text-ft14-17 focus:outline-none`}
          placeholder="Please enter your email"
          style={{
            backgroundColor: widgetSettings.backgroundColor,
            borderColor: widgetSettings.fontColor
          }}
        />

        <div className="mt-3 flex justify-between gap-1">
          <button
            className="h-10 w-40 rounded-full text-ft13-15.85-0.26 font-semibold "
            style={{
              backgroundColor: widgetSettings.buttonColor,
              color: widgetSettings.fontColor
            }}
          >
            Accept
          </button>

          <button
            className="h-10 w-40 rounded-full border text-ft13-15.85-0.26 font-semibold"
            style={{ borderColor: widgetSettings.fontColor }}
          >
            No Thanks!
          </button>
        </div>
      </div>
      <p className="mt-9 flex text-ft20-28 font-semibold md:text-ft26-30">
        Why Provide Consent?
      </p>
      <p className="mt-2.5 flex w-full text-center text-ft14-17 font-normal opacity-80">
        Understanding your consent allows us to know when, how, and IF we can
        use your data. It gives you control over what you see, but allows us to
        leverage insights to improve our business. With your permission, we
        would like to use some of your data and give you something tangible in
        return.
      </p>
    </div>
  );
};

const ConsentSection = ({ isConsentsEnabled, discount, widgetSettings }) => {
  return (
    <div className="flex min-h-112.5 flex-col">
      {isConsentsEnabled && discount ? (
        <div>
          <p className="mt-0 flex justify-center text-center text-ft31-38 font-bold">
            {`Get
                ${
                  Utils.isPurelyNumeric(discount)
                    ? discount + "% OFF"
                    : discount
                }
                and more!`}
          </p>
          <p className="mt-1 flex justify-center text-ft15 font-semibold ">
            if you track your consents
          </p>
        </div>
      ) : (
        <p className="mt-6 flex justify-center text-ft20-28 font-semibold md:text-ft26-30">
          Where is my data going?
        </p>
      )}
      <div className="mt-15 flex flex-row justify-between gap-17px">
        <button
          className="w-full rounded border py-11px text-ft15 font-medium"
          style={{ borderColor: widgetSettings.fontColor }}
        >
          Track via Email
        </button>

        <button
          className="w-full rounded py-11px text-ft15 font-medium"
          style={{
            backgroundColor: widgetSettings.buttonColor,
            color: widgetSettings.fontColor
          }}
        >
          Track via Extension
        </button>
      </div>
      <p className="mt-65px flex text-ft20-28 font-semibold md:text-ft26-30">
        Why Provide Consent?
      </p>
      <p className="mt-2.5 flex w-full text-ft14-17 font-normal opacity-80">
        Understanding your consent allows us to know when, how, and IF we can
        use your data. It gives you control over what you see, but allows us to
        leverage insights to improve our business. With your permission, we
        would like to use some of your data and give you something tangible in
        return.
      </p>
    </div>
  );
};

const SideWidget = ({
  isOnlyEmailConsent,
  isConsentsEnabled,
  discount,
  widgetSettings
}) => {
  return (
    <div className="size-full overflow-auto xs:block 2xl:flex 2xl:flex-col ">
      <div className="relative flex w-full">
        <div
          className="flex h-full w-131 min-w-80 flex-col border px-7.5 pt-12.5"
          style={{
            backgroundColor: widgetSettings.backgroundColor,
            color: widgetSettings.fontColor,
            fontFamily: widgetSettings?.font?.family
          }}
        >
          {isOnlyEmailConsent ? (
            <EmailMarketingSection
              isConsentsEnabled={isConsentsEnabled}
              discount={discount}
              widgetSettings={widgetSettings}
            />
          ) : (
            <ConsentSection
              isConsentsEnabled={isConsentsEnabled}
              discount={discount}
              widgetSettings={widgetSettings}
            />
          )}
          <p className="flex w-full justify-center gap-1 py-3 text-ft10-16 font-medium opacity-80">
            Powered by{" "}
            <span className="font-semibold opacity-100">Datasent</span>
          </p>
        </div>
      </div>
    </div>
  );
};
SideWidget.propTypes = {
  isOnlyEmailConsent: PropTypes.bool.isRequired,
  isConsentsEnabled: PropTypes.bool.isRequired,
  discount: PropTypes.number,
  widgetSettings: PropTypes.shape({
    backgroundColor: PropTypes.string,
    fontColor: PropTypes.string,
    font: PropTypes.shape({
      family: PropTypes.string
    })
  }).isRequired
};
ConsentSection.propTypes = {
  isConsentsEnabled: PropTypes.bool.isRequired,
  discount: PropTypes.number,
  widgetSettings: PropTypes.shape({
    buttonColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    fontColor: PropTypes.string
  }).isRequired
};
EmailMarketingSection.propTypes = {
  isConsentsEnabled: PropTypes.bool.isRequired,
  discount: PropTypes.number,
  widgetSettings: PropTypes.shape({
    buttonColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    fontColor: PropTypes.string,
    isEmailMarketingEnabled: PropTypes.bool
  }).isRequired
};

export default SideWidget;
